export enum AuditTrailsDateRangeType {
  Today = 'TODAY',
  LastWeek = 'LAST_WEEK',
  LastMonth = 'LAST_MONTH',
  Older = 'OLDER'
}
